function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup427318227(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 40,
    viewBox: "0 0 110 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group 427318227"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 530",
    x: 0.25,
    y: 0.25,
    width: 109.5,
    height: 39.5,
    rx: 4.75,
    stroke: "white",
    strokeOpacity: 0.4,
    style: {
      stroke: "white",
      stroke: "white",
      strokeOpacity: 0.4
    },
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup427318227);
export default __webpack_public_path__ + "static/media/Group 427318227.360e5caa83e52437d1e1939bd5dda404.svg";
export { ForwardRef as ReactComponent };